import { Fragment, useState } from 'react'
import { Media } from '@/components/Media'
import { describeLink, track } from '@/lib/analytics'
import { isPdfHref, resolveWithTicket } from '@/lib/api'
import type { FooterContent, SocialKey } from '@/lib/content.types'

/** 공식 브랜드 SVG. 프로토타입의 CSS 도형을 실제 로고로 교체했다. */
const SOCIAL_ICONS: Record<SocialKey, JSX.Element> = {
  linkedin: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.22.79 24 1.77 24h20.45c.98 0 1.78-.78 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
    </svg>
  ),
  instagram: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.3-1.46.72-2.13 1.38C1.35 2.68.93 3.35.63 4.14.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.3.79.72 1.46 1.38 2.13.67.66 1.34 1.08 2.13 1.38.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56.79-.3 1.46-.72 2.13-1.38.66-.67 1.08-1.34 1.38-2.13.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91-.3-.79-.72-1.46-1.38-2.13C21.32 1.35 20.65.93 19.86.63 19.1.33 18.22.13 16.95.07 15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm7.85-10.4a1.44 1.44 0 1 1-2.88 0 1.44 1.44 0 0 1 2.88 0z" />
    </svg>
  ),
  threads: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16.9 11.13a7.3 7.3 0 0 0-.28-.13c-.16-3.02-1.81-4.75-4.58-4.77h-.04c-1.66 0-3.04.71-3.89 2l1.53 1.05c.63-.96 1.63-1.17 2.36-1.17h.03c.9 0 1.59.27 2.03.79.32.38.54.9.64 1.56a12 12 0 0 0-2.6-.13c-2.62.15-4.3 1.68-4.19 3.8.06 1.08.6 2 1.51 2.6.78.5 1.78.75 2.82.7 1.37-.08 2.45-.6 3.2-1.56.57-.72.93-1.66 1.09-2.85.66.4 1.15.92 1.42 1.55.46 1.08.49 2.85-.95 4.29-1.27 1.26-2.79 1.81-5.09 1.83-2.55-.02-4.48-.84-5.73-2.43C7.03 16.75 6.42 14.6 6.4 12c.02-2.6.63-4.75 1.78-6.26 1.25-1.6 3.18-2.41 5.73-2.43 2.57.02 4.53.83 5.83 2.42.64.78 1.12 1.76 1.44 2.9l1.79-.48c-.39-1.4-1-2.61-1.84-3.6C19.47 2.5 17 1.44 13.92 1.42h-.01c-3.07.02-5.51 1.09-7.25 3.17C5.11 6.44 4.32 8.98 4.3 11.99v.02c.02 3.01.81 5.55 2.36 7.4 1.74 2.08 4.18 3.15 7.25 3.17h.01c2.73-.02 4.65-.73 6.24-2.31 2.08-2.07 2.02-4.67 1.33-6.27-.49-1.15-1.43-2.08-2.72-2.7zm-4.83 4.42c-1.15.07-2.34-.45-2.4-1.53-.05-.8.57-1.7 2.48-1.81.22-.01.43-.02.64-.02.7 0 1.34.07 1.93.2-.22 2.75-1.51 3.1-2.65 3.16z" />
    </svg>
  ),
  youtube: (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  ),
}

export function Footer({ data }: { data: FooterContent }) {
  const brochureHref = data.brochure?.href?.trim() ?? ''
  const brochureIsPdf = isPdfHref(brochureHref)
  const [downloading, setDownloading] = useState(false)

  const trackSocial = (key: SocialKey, href: string) =>
    track('Outbound Link Clicked', { link_location: 'footer_social', social_network: key, ...describeLink(href) })

  /** PDF 는 곧바로 다운로드, HTML 은 /brochure 화면을 새 탭으로 연다 */
  const trackBrochure = (method: string) =>
    track('Brochure Clicked', {
      brochure_format: brochureIsPdf ? 'pdf' : 'html',
      brochure_label: data.brochure?.label || 'Brochure',
      open_method: method,
    })

  /**
   * PDF 브로슈어는 화면에 띄우지 않고 **바로 내려받는다.**
   *
   * 업로드한 파일은 접근 티켓이 있어야 열리는데, 티켓은 비동기로 받아와야 해서
   * 링크에 미리 넣어둘 수 없다. 그래서 클릭을 가로채 티켓을 받은 뒤 그 주소로 이동시킨다.
   * 서버가 `Content-Disposition: attachment` 로 내려보내므로 이동이 아니라 다운로드가 되고,
   * 보고 있던 페이지는 그대로 남는다.
   */
  const downloadPdf = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return
    e.preventDefault()
    if (downloading) return
    setDownloading(true)
    try {
      window.location.href = await resolveWithTicket(brochureHref)
    } finally {
      // 다운로드는 페이지 이동이 아니라서 콜백이 없다 — 잠깐 뒤 버튼을 되살린다
      window.setTimeout(() => setDownloading(false), 2500)
    }
  }

  return (
    <footer id="footer" className="border-t border-line-hairline bg-surface-footer px-5 pb-10 pt-[52px] md:px-10">
      {/* 모바일에서는 전체 중앙 정렬, md 이상에서는 디자인대로 좌우 배치 */}
      <div className="mx-auto flex max-w-content flex-col items-center gap-10 text-center md:flex-row md:flex-wrap md:items-start md:justify-between md:text-left">
        <div>
          <div className="mb-4">
            <Media
              media={data.logo}
              className="mx-auto h-[22px] w-auto object-contain md:mx-0"
            />
          </div>
          <div className="text-[13.5px] leading-[1.7] text-ink-tertiary">
            {data.companyName}
            <br />
            {data.address.split('\n').map((line, i) => (
              <Fragment key={i}>
                {line}
                {i < data.address.split('\n').length - 1 && <br />}
              </Fragment>
            ))}
          </div>
          <div className="mt-[18px] text-xs text-ink-quaternary">{data.copyright}</div>
        </div>

        {/* SNS 아이콘 + 그 아래 브로슈어 버튼.
            모바일에서는 중앙, md 이상에서는 아이콘 오른쪽 끝에 맞춘다. */}
        <div className="flex flex-col items-center gap-4 md:items-end">
        <div className="flex gap-3">
          {data.socials.map((s) => (
            <a
              key={s.key}
              href={s.href}
              aria-label={s.label}
              onClick={() => trackSocial(s.key, s.href)}
              onAuxClick={(e) => {
                if (e.button === 1) trackSocial(s.key, s.href)
              }}
              target={s.href.startsWith('http') ? '_blank' : undefined}
              rel={s.href.startsWith('http') ? 'noreferrer noopener' : undefined}
              className="flex h-[38px] w-[38px] items-center justify-center rounded-full border border-line-control text-ink-secondary transition-colors hover:border-blue-brand hover:text-ink-primary"
            >
              {SOCIAL_ICONS[s.key]}
            </a>
          ))}
          </div>

          {/* 브로슈어 — 주소가 없으면 아예 그리지 않는다(죽은 버튼 방지).
              `?.` 는 오래된 seed 폴백 대비 (Studio.tsx 의 같은 주석 참고) */}
          {brochureHref && (
            <a
              // PDF는 곧바로 내려받고, HTML은 새 탭의 브로슈어 화면에서 연다
              href={brochureIsPdf ? brochureHref : '/brochure'}
              target={brochureIsPdf ? undefined : '_blank'}
              /**
               * HTML일 때 클릭을 가로채 `window.open` 으로 여는 이유는 Studio 카드와 같다 —
               * 브라우저가 `target="_blank"` 링크의 `window.opener` 를 강제로 끊어서,
               * 새 탭의 "← Back to site" 가 원래 탭으로 돌아갈 수 없기 때문이다.
               * (`sections/Studio.tsx` 주석 참고)
               */
              onAuxClick={(e) => {
                if (e.button === 1) trackBrochure('middle_click')
              }}
              onClick={
                brochureIsPdf
                  ? (e) => {
                      trackBrochure('click')
                      void downloadPdf(e)
                    }
                  : (e) => {
                      trackBrochure('click')
                      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return
                      e.preventDefault()
                      window.open(e.currentTarget.href, '_blank')
                    }
              }
              aria-busy={downloading || undefined}
              className="inline-flex items-center gap-2 rounded-pill border border-line-control px-4 py-2 text-[13px] font-semibold text-ink-secondary transition-colors hover:border-blue-brand hover:text-ink-primary"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              {downloading ? 'Preparing…' : data.brochure?.label || 'Brochure'}
            </a>
          )}
        </div>
      </div>
    </footer>
  )
}
